import React, { useState, useEffect } from 'react';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/utility/Page';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../style/color';
import axios from 'axios';
import { mainurl } from '../../Mainurl';

import { Row, Col, Card, CardBody, Button, Badge, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Alert, Table } from 'reactstrap';
import {FaList, FaRing, FaPlus, FaTimes, FaSave, FaTree, FaTable, FaMinus, FaChevronRight, FaChevronDown, FaFolder, FaFolderOpen, FaFileAlt} from 'react-icons/fa';

const ChartsOfAccount = () => {
    const [loading, setLoading] = useState(false);
    const [accountData, setAccountData] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [hierarchicalView, setHierarchicalView] = useState(true);
    const [expandedGroups, setExpandedGroups] = useState(new Set(['Assets', 'Assets -> Current Assets', 'Liabilities -> Current Liabilities']));
    const [hierarchicalData, setHierarchicalData] = useState(null);
    const [rawApiData, setRawApiData] = useState(null);
    const [formData, setFormData] = useState({
        coa_code: '',
        coa_name: '',
        coa_desc: '',
        coa_opening_balance: 0,
        coa_type: '',
        parent_id: ''
    });
    const [formErrors, setFormErrors] = useState({});
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        fetchChartsOfAccount();
    }, []);

    const fetchChartsOfAccount = () => {
        setLoading(true);
        setAccountData([]);
        
        let postData = [{
            "org_id": sessionStorage.getItem('org_id'), 
            "user_id": sessionStorage.getItem('user_id')
        }];
        
        axios({
            method: 'post',
            url: `${mainurl}Accounts/coa`,
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                console.log('Chart of Accounts API Response:', response.data);
                setRawApiData(response.data);
                
                if (response.data && response.data.length > 0 && response.data[0].hierarchical_coa_json) {
                    try {
                        const hierarchicalDataParsed = JSON.parse(response.data[0].hierarchical_coa_json);
                        console.log('Parsed Hierarchical COA:', hierarchicalDataParsed);
                        setHierarchicalData(hierarchicalDataParsed);
                        
                        let accountList = [];
                        let accountIndex = 1;
                        
                        // Process each group in the chart of accounts
                        if (hierarchicalDataParsed.chart_of_accounts && Array.isArray(hierarchicalDataParsed.chart_of_accounts)) {
                            hierarchicalDataParsed.chart_of_accounts.forEach(groupItem => {
                                const groupInfo = groupItem.group_info;
                                const accounts = groupItem.accounts;                                        // Process accounts within this group
                                        if (accounts && Array.isArray(accounts)) {
                                            accounts.forEach(account => {
                                                // Determine normal balance based on account type
                                                let normal_balance = 'Debit';
                                                if (account.account_type === 'Liability' || 
                                                    account.account_type === 'Equity' || 
                                                    account.account_type === 'Revenue') {
                                                    normal_balance = 'Credit';
                                                }
                                                
                                                // Determine account status
                                                const status = (account.current_balance !== null && account.current_balance !== undefined) || 
                                                             (account.total_debits > 0 || account.total_credits > 0) ? 'Active' : 'Inactive';
                                                
                                                accountList.push({
                                                    id: accountIndex++,
                                                    account_code: account.account_code || 'N/A',
                                                    account_name: account.account_name || 'N/A',
                                                    account_type: account.account_type || 'N/A',
                                                    normal_balance: normal_balance,
                                                    status: status,
                                                    // Additional fields for reference
                                                    group_path: groupInfo.full_path,
                                                    group_level: groupInfo.level,
                                                    current_balance: account.current_balance || 0,
                                                    total_debits: account.total_debits || 0,
                                                    total_credits: account.total_credits || 0,
                                                    last_transaction_date: account.last_transaction_date,
                                                    last_updated: account.last_updated
                                                });
                                            });
                                        }
                            });
                        }
                        
                        console.log('Processed Account List:', accountList);
                        setAccountData(accountList);
                        
                    } catch (error) {
                        console.error('Error parsing hierarchical COA JSON:', error);
                        setAccountData([]);
                    }
                } else {
                    // Sample hierarchical data matching the provided API structure
                    console.log('No data received, using sample hierarchical data');
                    const sampleHierarchicalData = {
                        "chart_of_accounts": [
                            {
                                "accounts": [
                                    {
                                        "account_id": 19,
                                        "description": "SBI",
                                        "account_code": "1001",
                                        "account_name": "SBI",
                                        "account_type": "Asset",
                                        "last_updated": "2025-07-05 07:04:39.000000",
                                        "total_debits": 4540.00,
                                        "total_credits": 2500.00,
                                        "current_balance": 97960.00,
                                        "last_transaction_date": "2025-07-06"
                                    }
                                ],
                                "group_info": {
                                    "path": "1",
                                    "level": 0,
                                    "summary": {
                                        "total_debits": 4540.00,
                                        "account_count": 1,
                                        "total_credits": 2500.00,
                                        "current_balance": 97960.00
                                    },
                                    "group_id": 1,
                                    "full_path": "Assets",
                                    "group_name": "Assets",
                                    "description": "Resources owned by the business",
                                    "parent_group_id": null
                                }
                            },
                            {
                                "accounts": [
                                    {
                                        "account_id": 1,
                                        "description": "Cash on hand and in bank",
                                        "account_code": "1000",
                                        "account_name": "Cash",
                                        "account_type": "Asset",
                                        "last_updated": null,
                                        "total_debits": 0.00,
                                        "total_credits": 0.00,
                                        "current_balance": 0.00,
                                        "last_transaction_date": null
                                    },
                                    {
                                        "account_id": 2,
                                        "description": "Amounts owed by customers",
                                        "account_code": "1100",
                                        "account_name": "Accounts Receivable",
                                        "account_type": "Asset",
                                        "last_updated": null,
                                        "total_debits": 0.00,
                                        "total_credits": 0.00,
                                        "current_balance": 0.00,
                                        "last_transaction_date": null
                                    }
                                ],
                                "group_info": {
                                    "path": "1->6",
                                    "level": 1,
                                    "summary": {
                                        "total_debits": 0.00,
                                        "account_count": 2,
                                        "total_credits": 0.00,
                                        "current_balance": 0.00
                                    },
                                    "group_id": 6,
                                    "full_path": "Assets -> Current Assets",
                                    "group_name": "Current Assets",
                                    "description": "Assets expected to be converted to cash within one year",
                                    "parent_group_id": 1
                                }
                            },
                            {
                                "accounts": [
                                    {
                                        "account_id": 6,
                                        "description": "Amounts owed to suppliers",
                                        "account_code": "2000",
                                        "account_name": "Accounts Payable",
                                        "account_type": "Liability",
                                        "last_updated": null,
                                        "total_debits": 0.00,
                                        "total_credits": 0.00,
                                        "current_balance": 0.00,
                                        "last_transaction_date": null
                                    }
                                ],
                                "group_info": {
                                    "path": "2->8",
                                    "level": 1,
                                    "summary": {
                                        "total_debits": 0.00,
                                        "account_count": 1,
                                        "total_credits": 0.00,
                                        "current_balance": 0.00
                                    },
                                    "group_id": 8,
                                    "full_path": "Liabilities -> Current Liabilities",
                                    "group_name": "Current Liabilities",
                                    "description": "Obligations due within one year",
                                    "parent_group_id": 2
                                }
                            }
                        ]
                    };
                    
                    setHierarchicalData(sampleHierarchicalData);
                    
                    // Also process this sample data into flat accountData for the DataTable view
                    let accountList = [];
                    let accountIndex = 1;
                    setAccountData([
                        {
                            id: 1,
                            account_code: '1000',
                            account_name: 'Cash - Operating Account',
                            account_type: 'Asset',
                            normal_balance: 'Debit',
                            status: 'Active'
                        },
                        {
                            id: 2,
                            account_code: '1010',
                            account_name: 'Cash - Savings Account',
                            account_type: 'Asset',
                            normal_balance: 'Debit',
                            status: 'Active'
                        },
                        {
                            id: 3,
                            account_code: '1100',
                            account_name: 'Accounts Receivable',
                            account_type: 'Asset',
                            normal_balance: 'Debit',
                            status: 'Active'
                        },
                        {
                            id: 4,
                            account_code: '1110',
                            account_name: 'Allowance for Doubtful Accounts',
                            account_type: 'Asset',
                            normal_balance: 'Credit',
                            status: 'Active'
                        },
                        {
                            id: 5,
                            account_code: '1500',
                            account_name: 'Land',
                            account_type: 'Asset',
                            normal_balance: 'Debit',
                            status: 'Active'
                        },
                        {
                            id: 6,
                            account_code: '1510',
                            account_name: 'Buildings',
                            account_type: 'Asset',
                            normal_balance: 'Debit',
                            status: 'Active'
                        },
                        {
                            id: 7,
                            account_code: '2000',
                            account_name: 'Accounts Payable',
                            account_type: 'Liability',
                            normal_balance: 'Credit',
                            status: 'Active'
                        },
                        {
                            id: 8,
                            account_code: '2500',
                            account_name: 'Long-term Notes Payable',
                            account_type: 'Liability',
                            normal_balance: 'Credit',
                            status: 'Active'
                        },
                        {
                            id: 9,
                            account_code: '3000',
                            account_name: 'Common Stock',
                            account_type: 'Equity',
                            normal_balance: 'Credit',
                            status: 'Active'
                        },
                        {
                            id: 10,
                            account_code: '4000',
                            account_name: 'Sales Revenue',
                            account_type: 'Revenue',
                            normal_balance: 'Credit',
                            status: 'Active'
                        },
                        {
                            id: 11,
                            account_code: '5000',
                            account_name: 'Cost of Goods Sold',
                            account_type: 'Expense',
                            normal_balance: 'Debit',
                            status: 'Active'
                        },
                        {
                            id: 12,
                            account_code: '6000',
                            account_name: 'Salaries and Wages',
                            account_type: 'Expense',
                            normal_balance: 'Debit',
                            status: 'Active'
                        }
                    ]);
                }
                setLoading(false);
            })
            .catch(error => {
                console.error('Chart of Accounts API Error:', error);
                setLoading(false);
                
                // Show sample data on error
                setAccountData([
                    {
                        id: 1,
                        account_code: 'ERROR',
                        account_name: 'Sample Account (Error)',
                        account_type: 'Asset',
                        normal_balance: 'Debit',
                        status: 'Active'
                    }
                ]);
            });
    };

    const refresh_handler = () => {
        fetchChartsOfAccount();
    };

    // Modal handlers
    const openModal = () => {
        setModalOpen(true);
        setFormData({
            coa_code: '',
            coa_name: '',
            coa_desc: '',
            coa_opening_balance: 0,
            coa_type: '',
            parent_id: ''
        });
        setFormErrors({});
    };

    const closeModal = () => {
        setModalOpen(false);
        setFormData({
            coa_code: '',
            coa_name: '',
            coa_desc: '',
            coa_opening_balance: 0,
            coa_type: '',
            parent_id: ''
        });
        setFormErrors({});
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
        
        // Clear error when user starts typing
        if (formErrors[name]) {
            setFormErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const validateForm = () => {
        const errors = {};
        
        if (!formData.coa_code.toString().trim()) {
            errors.coa_code = 'Account code is required';
        }
        if (!formData.coa_name.trim()) {
            errors.coa_name = 'Account name is required';
        }
        if (!formData.coa_type) {
            errors.coa_type = 'Account type is required';
        }
        if (!formData.coa_desc.trim()) {
            errors.coa_desc = 'Description is required';
        }
        if (isNaN(formData.coa_opening_balance) || formData.coa_opening_balance < 0) {
            errors.coa_opening_balance = 'Opening balance must be a valid number';
        }
        
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!validateForm()) {
            return;
        }
        
        setSubmitting(true);
        
        try {
            // Get account_code from selected parent account
            const selectedParent = accountData.find(acc => acc.id === parseInt(formData.parent_id));
            const account_code = selectedParent ? parseInt(selectedParent.account_code) : null;
            
            const postData = [{
                "org_id": parseInt(sessionStorage.getItem('org_id')),
                "user_id": parseInt(sessionStorage.getItem('user_id')),
                "coa_name": formData.coa_name,
                "coa_desc": formData.coa_desc,
                "coa_code": parseInt(formData.coa_code),
                "coa_opening_balance": parseFloat(formData.coa_opening_balance) || 0,
                "coa_type": formData.coa_type,
                "account_code": account_code,
                "parent_id": formData.parent_id ? parseInt(formData.parent_id) : null
            }];
            
            console.log('Add Account Data:', JSON.stringify(postData));
            
            const response = await axios({
                method: 'post',
                url: mainurl + 'Accounts/coa_add',
                data: postData,
                headers: { 'Content-Type': 'application/JSON' }
            });
            
            console.log('Add Account Response:', response.data);
            
            // Close modal and refresh data
            closeModal();
            fetchChartsOfAccount();
            
        } catch (error) {
            console.error('Add Account Error:', error);
            setFormErrors({ submit: 'Failed to add account. Please try again.' });
        } finally {
            setSubmitting(false);
        }
    };

    // Hierarchy options
    const accountTypeOptions = [
        { value: 'Asset', label: 'Asset' },
        { value: 'Liability', label: 'Liability' },
        { value: 'Equity', label: 'Equity' },
        { value: 'Revenue', label: 'Revenue' },
        { value: 'Expense', label: 'Expense' }
    ];

    // Get available parent accounts based on account type
    const getParentAccountOptions = () => {
        if (!formData.coa_type) return [];
        
        return accountData.filter(account => 
            account.account_type === formData.coa_type &&
            account.parent_account === 'None' // Only parent accounts can be parents
        );
    };

    // Get status badge color
    const getStatusBadge = (status) => {
        return status === 'Active' ? 'success' : 'secondary';
    };

    // Get balance type badge color
    const getBalanceTypeBadge = (balanceType) => {
        return balanceType === 'Debit' ? 'info' : 'warning';
    };

    // Get account type badge color
    const getAccountTypeBadge = (accountType) => {
        const colors = {
            'Asset': 'primary',
            'Liability': 'danger',
            'Equity': 'success',
            'Revenue': 'info',
            'Expense': 'warning'
        };
        return colors[accountType] || 'secondary';
    };

    const chartColumns = [
        {
            name: 'Account Code',
            selector: row => row.account_code,
            sortable: true,
            width: '15%',
            cell: row => (
                <div style={{
                    whiteSpace: 'normal', 
                    wordBreak: 'break-word',
                    fontWeight: 'bold',
                    fontFamily: 'monospace',
                    fontSize: '0.9em'
                }}>
                    {row.account_code}
                </div>
            )
        },
        {
            name: 'Account Name',
            selector: row => row.account_name,
            sortable: true,
            width: '35%',
            cell: row => (
                <div style={{
                    whiteSpace: 'normal', 
                    wordBreak: 'break-word',
                    fontWeight: '500'
                }}>
                    {hierarchicalView && row.group_level > 0 && (
                        <span style={{ 
                            marginRight: '8px', 
                            color: '#6c757d',
                            fontSize: '0.8em'
                        }}>
                            {'└─'.repeat(row.group_level)}
                        </span>
                    )}
                    {row.account_name}
                    {hierarchicalView && row.group_path && (
                        <><br />
                        <small className="text-muted" style={{ fontSize: '0.75em' }}>
                            {row.group_path}
                        </small></>
                    )}
                </div>
            )
        },
        {
            name: 'Type',
            selector: row => row.account_type,
            sortable: true,
            width: '15%',
            cell: row => <Badge color={getAccountTypeBadge(row.account_type)}>{row.account_type}</Badge>
        },
        {
            name: 'Normal Balance',
            selector: row => row.normal_balance,
            sortable: true,
            width: '15%',
            cell: row => <Badge color={getBalanceTypeBadge(row.normal_balance)}>{row.normal_balance}</Badge>
        },
        {
            name: 'Status',
            selector: row => row.status,
            sortable: true,
            width: '10%',
            cell: row => <Badge color={getStatusBadge(row.status)}>{row.status}</Badge>
        },
        {
            name: 'Current Balance',
            selector: row => row.current_balance,
            sortable: true,
            width: '20%',
            cell: row => (
                <div style={{
                    whiteSpace: 'normal', 
                    textAlign: 'right',
                    fontFamily: 'monospace',
                    fontSize: '0.9em',
                    color: row.current_balance > 0 ? '#28a745' : row.current_balance < 0 ? '#dc3545' : '#6c757d'
                }}>
                    ₹ {Math.abs(row.current_balance || 0).toLocaleString('en-IN', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}
                    {row.current_balance !== 0 && (
                        <><br />
                        <Badge color={row.current_balance > 0 ? 'success' : 'danger'} className="text-tiny">
                            {row.current_balance > 0 ? 'Dr' : 'Cr'}
                        </Badge></>
                    )}
                </div>
            )
        }
    ];

    // Statistics
    const totalAccounts = accountData.length;
    const activeAccounts = accountData.filter(acc => acc.status === 'Active').length;
    const inactiveAccounts = accountData.filter(acc => acc.status === 'Inactive').length;
    const accountsByType = accountData.reduce((acc, curr) => {
        acc[curr.account_type] = (acc[curr.account_type] || 0) + 1;
        return acc;
    }, {});
    
    // Balance statistics
    const totalAssetBalance = accountData.filter(acc => acc.account_type === 'Asset').reduce((sum, acc) => sum + (acc.current_balance || 0), 0);
    const totalLiabilityBalance = accountData.filter(acc => acc.account_type === 'Liability').reduce((sum, acc) => sum + Math.abs(acc.current_balance || 0), 0);
    const totalEquityBalance = accountData.filter(acc => acc.account_type === 'Equity').reduce((sum, acc) => sum + Math.abs(acc.current_balance || 0), 0);
    const totalRevenueBalance = accountData.filter(acc => acc.account_type === 'Revenue').reduce((sum, acc) => sum + Math.abs(acc.current_balance || 0), 0);
    const totalExpenseBalance = accountData.filter(acc => acc.account_type === 'Expense').reduce((sum, acc) => sum + (acc.current_balance || 0), 0);
    const accountsWithBalance = accountData.filter(acc => (acc.current_balance || 0) !== 0).length;

    // Helper function to sort accounts hierarchically
    const getSortedAccountData = () => {
        if (accountData.length === 0) return [];
        
        // Sort by group path and then by account code within each group
        return [...accountData].sort((a, b) => {
            // First sort by group level (parents before children)
            if (a.group_level !== b.group_level) {
                return a.group_level - b.group_level;
            }
            
            // Then sort by group path
            if (a.group_path !== b.group_path) {
                return a.group_path.localeCompare(b.group_path);
            }
            
            // Finally sort by account code within the same group
            return a.account_code.localeCompare(b.account_code);
        });
    };

    // Toggle group expansion/collapse
    const toggleGroupExpansion = (groupPath) => {
        const newExpanded = new Set(expandedGroups);
        if (newExpanded.has(groupPath)) {
            newExpanded.delete(groupPath);
        } else {
            newExpanded.add(groupPath);
        }
        setExpandedGroups(newExpanded);
    };

    // Build a nested group tree from the flat chart_of_accounts array
const buildGroupTree = (flatGroups) => {
    if (!flatGroups) return [];
    const groupMap = {};
    const rootGroups = [];

    // First, map all groups by group_id
    flatGroups.forEach(item => {
        const group = item.group_info;
        if (!group) return;
        groupMap[group.group_id] = {
            ...group,
            accounts: item.accounts || [],
            children: []
        };
    });

    // Then, link children to their parent
    Object.values(groupMap).forEach(group => {
        if (group.parent_group_id && groupMap[group.parent_group_id]) {
            groupMap[group.parent_group_id].children.push(group);
        } else {
            rootGroups.push(group);
        }
    });

    return rootGroups;
};

    // Recursive render for group rows (all levels)
    const renderGroupRows = (groups, level = 0, parentPath = '') => {
        if (!groups || !Array.isArray(groups)) return null;
        const rows = [];

        groups.forEach(group => {
            const groupPath = group.full_path || group.group_name;
            const isExpanded = expandedGroups.has(groupPath);
            const canExpand = (group.children && group.children.length > 0) || (group.accounts && group.accounts.length > 0);

            // Group row
            rows.push(
                <tr key={groupPath} style={{ backgroundColor: level === 0 ? '#f8f9fa' : 'transparent' }}>
                    <td style={{ paddingLeft: `${level * 20 + 10}px` }}>
                        <div className="d-flex align-items-center">
                            {canExpand && (
                                <span
                                    style={{ cursor: 'pointer', marginRight: '8px' }}
                                    onClick={() => toggleGroupExpansion(groupPath)}
                            >
                                {isExpanded ? 
                                    <FaMinus className="text-danger" size={12} /> : 
                                    <FaPlus className="text-success" size={12} />
                                }
                            </span>
                            )}
                            <strong style={{ fontSize: level === 0 ? '1em' : '0.9em' }}>
                                {group.group_name}
                                {group.summary && (
                                    <span style={{ fontSize: '0.8em', color: '#6c757d', marginLeft: '10px' }}>
                                        ({group.summary.account_count || 0} accounts)
                                    </span>
                                )}
                            </strong>
                        </div>
                    </td>
                    <td>
                        <Badge color={getAccountTypeBadge(group.group_name)}>{group.group_name}</Badge>
                    </td>
                    <td style={{ color: '#6c757d' }}>—</td>
                    <td style={{ color: '#6c757d' }}>—</td>
                    <td style={{ 
                        color: '#6c757d', 
                        textAlign: 'right',
                        fontFamily: 'monospace',
                        fontSize: '0.9em'
                    }}>
                        {group.summary && group.summary.current_balance !== null && group.summary.current_balance !== undefined ? (
                            <>
                                ₹ {Math.abs(group.summary.current_balance).toLocaleString('en-IN', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}
                                <br />
                                <Badge color={group.summary.current_balance >= 0 ? 'success' : 'danger'} size="sm">
                                    {group.summary.current_balance >= 0 ? 'Dr' : 'Cr'}
                                </Badge>
                            </>
                        ) : '—'}
                    </td>
                </tr>
            );

            // Render accounts if expanded
            if (isExpanded && group.accounts && group.accounts.length > 0) {
                group.accounts.forEach(account => {
                    const normal_balance = (account.account_type === 'Liability' || account.account_type === 'Equity' || account.account_type === 'Revenue') ? 'Credit' : 'Debit';
                    const status = (account.current_balance !== null && account.current_balance !== undefined) || 
                                   (account.total_debits > 0 || account.total_credits > 0) ? 'Active' : 'Inactive';
                    rows.push(
                        <tr key={account.account_id} style={{ backgroundColor: '#fff' }}>
                            <td style={{ paddingLeft: `${(level + 1) * 20 + 10}px` }}>
                                <span style={{ fontFamily: 'monospace', fontWeight: 'bold', marginRight: 8 }}>{account.account_code}</span>
                                {account.account_name}
                            </td>
                            <td>
                                <Badge color={getAccountTypeBadge(account.account_type)}>{account.account_type}</Badge>
                            </td>
                            <td>
                                <Badge color={getBalanceTypeBadge(normal_balance)}>{normal_balance}</Badge>
                            </td>
                            <td>
                                <Badge color={getStatusBadge(status)}>{status}</Badge>
                            </td>
                            <td style={{
                                textAlign: 'right',
                                fontFamily: 'monospace',
                                fontSize: '0.9em',
                                color: account.current_balance > 0 ? '#28a745' : account.current_balance < 0 ? '#dc3545' : '#6c757d'
                            }}>
                                ₹ {Math.abs(account.current_balance || 0).toLocaleString('en-IN', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}
                                {account.current_balance !== 0 && (
                                    <>
                                        <br />
                                        <Badge color={account.current_balance > 0 ? 'success' : 'danger'} className="text-tiny">
                                            {account.current_balance > 0 ? 'Dr' : 'Cr'}
                                        </Badge>
                                    </>
                                )}
                            </td>
                        </tr>
                    );
                });
            }

            // Recursively render child groups if expanded
            if (isExpanded && group.children && group.children.length > 0) {
                rows.push(...renderGroupRows(group.children, level + 1, groupPath));
            }
        });

        return rows;
    };

    return (
        <>
            <Header />
            <Page title='Chart of Accounts' breadcrumbs='Home / Financial / Chart of Accounts'>
                <Row className='p-3'>
                    <Col xs={12}>
                        {/* Action Buttons */}
                        <Card className='mb-3' color="primary" outline>
                            <CardBody>
                                <Row className='align-items-center'>
                                    <Col>
                                        <h6 className='mb-0'>
                                            <FaList className='me-2' />
                                            Chart of Accounts Management
                                        </h6>
                                    </Col>
                                    <Col xs="auto">
                                        <Button 
                                            className='text-white me-2' 
                                            color='success' 
                                            size="sm"
                                            onClick={openModal}
                                        > 
                                            <FaPlus className='me-1' size={14} /> Add New Account
                                        </Button>
                                        <Button 
                                            className='text-white me-2' 
                                            color={hierarchicalView ? 'info' : 'secondary'}
                                            size="sm"
                                            onClick={() => setHierarchicalView(!hierarchicalView)}
                                        > 
                                            {hierarchicalView ? <FaTree className='me-1' size={14} /> : <FaTable className='me-1' size={14} />}
                                            {hierarchicalView ? 'Tree View' : 'Flat View'}
                                        </Button>
                                        <Button 
                                            className='text-white' 
                                            color='secondary' 
                                            size="sm" 
                                            onClick={refresh_handler}
                                        > 
                                            <FaRing className='me-1' size={14} /> Refresh
                                        </Button>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>

                        {/* Statistics Cards */}
                        {accountData.length > 0 && (
                            <>
                                <Row className='mb-3'>
                                    <Col md={2}>
                                        <Card className='text-center' color="primary" outline>
                                            <CardBody className='py-3'>
                                                <h6 className='text-primary mb-1'>Total Accounts</h6>
                                                <h4 className='text-primary mb-0'>{totalAccounts}</h4>
                                                <small className="text-muted">{accountsWithBalance} with balance</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={2}>
                                        <Card className='text-center' color="success" outline>
                                            <CardBody className='py-3'>
                                                <h6 className='text-success mb-1'>Active</h6>
                                                <h4 className='text-success mb-0'>{activeAccounts}</h4>
                                                <small className="text-muted">{inactiveAccounts} inactive</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={2}>
                                        <Card className='text-center' color="info" outline>
                                            <CardBody className='py-3'>
                                                <h6 className='text-info mb-1'>Assets</h6>
                                                <h4 className='text-info mb-0'>{accountsByType.Asset || 0}</h4>
                                                <small className="text-muted">₹ {totalAssetBalance.toLocaleString('en-IN')}</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={2}>
                                        <Card className='text-center' color="danger" outline>
                                            <CardBody className='py-3'>
                                                <h6 className='text-danger mb-1'>Liabilities</h6>
                                                <h4 className='text-danger mb-0'>{accountsByType.Liability || 0}</h4>
                                                <small className="text-muted">₹ {totalLiabilityBalance.toLocaleString('en-IN')}</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={2}>
                                        <Card className='text-center' color="warning" outline>
                                            <CardBody className='py-3'>
                                                <h6 className='text-warning mb-1'>Revenue</h6>
                                                <h4 className='text-warning mb-0'>{accountsByType.Revenue || 0}</h4>
                                                <small className="text-muted">₹ {totalRevenueBalance.toLocaleString('en-IN')}</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={2}>
                                        <Card className='text-center' color="secondary" outline>
                                            <CardBody className='py-3'>
                                                <h6 className='text-secondary mb-1'>Expenses</h6>
                                                <h4 className='text-secondary mb-0'>{accountsByType.Expense || 0}</h4>
                                                <small className="text-muted">₹ {totalExpenseBalance.toLocaleString('en-IN')}</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </>
                        )}

                        {/* Chart of Accounts Table */}
                        <Card className='mb-3' color="secondary" outline>
                            <CardBody>
                                <h6 className='mb-3'>
                                    {hierarchicalView ? <FaTree className='me-2' /> : <FaList className='me-2' />}
                                    All Accounts {hierarchicalView ? '(Hierarchical View)' : '(Flat View)'}
                                </h6>

                                {hierarchicalView && hierarchicalData ? (
                                    /* Hierarchical Table View - Similar to Trial Balance */
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-sm">
                                            <thead style={{ backgroundColor: '#f8f9fa' }}>
                                                <tr>
                                                    <th style={{ width: '40%' }}>Account Code / Name</th>
                                                    <th style={{ width: '15%' }}>Type</th>
                                                    <th style={{ width: '15%' }}>Normal Balance</th>
                                                    <th style={{ width: '10%' }}>Status</th>
                                                    <th style={{ width: '20%', textAlign: 'right' }}>Current Balance</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {hierarchicalData.chart_of_accounts && renderGroupRows(buildGroupTree(hierarchicalData.chart_of_accounts))}
                                            </tbody>
                                        </table>
                                        
                                        {rawApiData && (
                                            <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
                                                <h6 style={{ color: '#6c757d', fontSize: '0.9em', marginBottom: '10px' }}>
                                                    <FaFileAlt className='me-2' />
                                                    Raw API Response (for debugging):
                                                </h6>
                                                <pre style={{ 
                                                    fontSize: '0.7em', 
                                                    color: '#495057', 
                                                    backgroundColor: '#fff', 
                                                    padding: '10px', 
                                                    borderRadius: '3px',
                                                    maxHeight: '300px',
                                                    overflow: 'auto'
                                                }}>
                                                    {JSON.stringify(rawApiData, null, 2)}
                                                </pre>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    /* Flat DataTable View */
                                    <DataTable
                                        title=""
                                        customStyles={{
                                            ...custTableStyles,
                                            cells: {
                                                style: {
                                                    whiteSpace: 'normal',
                                                    wordBreak: 'break-word',
                                                    padding: '8px',
                                                    minHeight: '50px',
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }
                                            },
                                            headCells: {
                                                style: {
                                                    whiteSpace: 'normal',
                                                    wordBreak: 'break-word',
                                                    padding: '8px',
                                                    fontWeight: 'bold',
                                                    backgroundColor: '#e9ecef'
                                                }
                                            }
                                        }}
                                        columns={chartColumns}
                                        data={getSortedAccountData()}
                                        highlightOnHover
                                        progressPending={loading}
                                        noDataComponent="No accounts found. Click Refresh to load data."
                                        pagination
                                        paginationPerPage={15}
                                        paginationRowsPerPageOptions={[10, 15, 20, 25, 50]}
                                    />
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                {/* Add Account Modal */}
                <Modal isOpen={modalOpen} toggle={closeModal} size="lg">
                    <ModalHeader toggle={closeModal}>
                        <FaPlus className='me-2' />
                        Add New Account
                    </ModalHeader>
                    <Form onSubmit={handleSubmit}>
                        <ModalBody>
                            {formErrors.submit && (
                                <Alert color="danger" className="mb-3">
                                    {formErrors.submit}
                                </Alert>
                            )}

                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="coa_code">COA Code *</Label>
                                        <Input
                                            type="number"
                                            name="coa_code"
                                            id="coa_code"
                                            placeholder="e.g., 1003"
                                            value={formData.coa_code}
                                            onChange={handleInputChange}
                                            invalid={!!formErrors.coa_code}
                                        />
                                        {formErrors.coa_code && (
                                            <div className="invalid-feedback">{formErrors.coa_code}</div>
                                        )}
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="coa_name">Account Name *</Label>
                                        <Input
                                            type="text"
                                            name="coa_name"
                                            id="coa_name"
                                            placeholder="e.g., Cash"
                                            value={formData.coa_name}
                                            onChange={handleInputChange}
                                            invalid={!!formErrors.coa_name}
                                        />
                                        {formErrors.coa_name && (
                                            <div className="invalid-feedback">{formErrors.coa_name}</div>
                                        )}
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="coa_type">Account Type *</Label>
                                        <Input
                                            type="select"
                                            name="coa_type"
                                            id="coa_type"
                                            value={formData.coa_type}
                                            onChange={handleInputChange}
                                            invalid={!!formErrors.coa_type}
                                        >
                                            <option value="">Select Account Type</option>
                                            {accountTypeOptions.map(option => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </Input>
                                        {formErrors.coa_type && (
                                            <div className="invalid-feedback">{formErrors.coa_type}</div>
                                        )}
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="parent_id">Parent Account (Optional)</Label>
                                        <Input
                                            type="select"
                                            name="parent_id"
                                            id="parent_id"
                                            value={formData.parent_id}
                                            onChange={handleInputChange}
                                            disabled={!formData.coa_type}
                                        >
                                            <option value="">No Parent (Top Level)</option>
                                            {getParentAccountOptions().map(account => (
                                                <option key={account.id} value={account.id}>
                                                    {account.account_code} - {account.account_name}
                                                </option>
                                            ))}
                                        </Input>
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="coa_opening_balance">Opening Balance</Label>
                                        <Input
                                            type="number"
                                            name="coa_opening_balance"
                                            id="coa_opening_balance"
                                            placeholder="e.g., 10000"
                                            value={formData.coa_opening_balance}
                                            onChange={handleInputChange}
                                            invalid={!!formErrors.coa_opening_balance}
                                            min="0"
                                            step="0.01"
                                        />
                                        {formErrors.coa_opening_balance && (
                                            <div className="invalid-feedback">{formErrors.coa_opening_balance}</div>
                                        )}
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    {/* Empty column for spacing */}
                                </Col>
                            </Row>

                            <Row>
                                <Col md={12}>
                                    <FormGroup>
                                        <Label for="coa_desc">Description *</Label>
                                        <Input
                                            type="textarea"
                                            name="coa_desc"
                                            id="coa_desc"
                                            placeholder="e.g., Cash in hand"
                                            rows="3"
                                            value={formData.coa_desc}
                                            onChange={handleInputChange}
                                            invalid={!!formErrors.coa_desc}
                                        />
                                        {formErrors.coa_desc && (
                                            <div className="invalid-feedback">{formErrors.coa_desc}</div>
                                        )}
                                    </FormGroup>
                                </Col>
                            </Row>

                            {/* Hierarchy Preview */}
                            {formData.coa_type && formData.coa_name && (
                                <Row className="mt-3">
                                    <Col md={12}>
                                        <div className="p-3 bg-light rounded">
                                            <h6 className="mb-2">Account Hierarchy Preview:</h6>
                                            <div className="hierarchy-preview">
                                                <div><strong>1.</strong> {formData.coa_type}</div>
                                                {formData.parent_id && (
                                                    <div className="ms-3">
                                                        <strong>2.</strong> {accountData.find(acc => acc.id === parseInt(formData.parent_id))?.account_name || 'Parent Account'}
                                                    </div>
                                                )}
                                                <div className={formData.parent_id ? "ms-4" : "ms-3"}>
                                                    <strong>{formData.parent_id ? '3.' : '2.'}</strong> {formData.coa_name || 'New Account'}
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            )}
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={closeModal} disabled={submitting}>
                                <FaTimes className='me-1' size={14} />
                                Cancel
                            </Button>
                            <Button color="success" type="submit" disabled={submitting}>
                                <FaSave className='me-1' size={14} />
                                {submitting ? 'Adding...' : 'Add Account'}
                            </Button>
                        </ModalFooter>
                    </Form>
                </Modal>
            </Page>
            <Footer />
        </>
    );
};

export default ChartsOfAccount;
